import React, { Component } from 'react';
import { ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { getSlot, propagateProps } from '@philips-internal/oswald-ui-utils';
import './filtered-list.css';
const FilterContainer = {
    acceptedTyepes: [
        ComponentType.BEHAVIOR,
        ComponentType.FORM,
    ],
    name: 'filter',
};
const ListContainer = {
    acceptedTypes: [
        ComponentType.BEHAVIOR,
        ComponentType.LAYOUT,
        ComponentType.LIST,
    ],
    name: 'list',
};
class FilteredList extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            parameters: {},
            reset: false,
        };
        this.onSubmit = ({ record }) => {
            this.setState({
                parameters: record,
                reset: true,
            }, () => this.setState({ reset: false }));
        };
    }
    renderFilter() {
        const filterAreaChild = getSlot(this.props.children, 'filter');
        return propagateProps(filterAreaChild, {
            onSubmit: this.onSubmit,
        });
    }
    renderList() {
        const listAreaChild = getSlot(this.props.children, 'list');
        return propagateProps(listAreaChild, {
            parameters: this.state.parameters,
            reset: this.state.reset,
        });
    }
    render() {
        const { uuid } = this.props;
        return (React.createElement("div", { className: "c-filtered-list" },
            React.createElement(Container, { acceptedTypes: FilterContainer.acceptedTyepes, className: "c-filtered-list__filter", slot: FilterContainer.name, uuid: uuid }, this.renderFilter()),
            React.createElement(Container, { acceptedTypes: ListContainer.acceptedTypes, className: "c-filtered-list__list", slot: ListContainer.name, uuid: uuid }, this.renderList())));
    }
}
export { FilterContainer, ListContainer, FilteredList, };
export default FilteredList;
//# sourceMappingURL=filtered-list.js.map